import {startsWith} from "lodash/string";

export const postMessageTypes = {
  getResponded: 'ms-survey-get-responded',
  setResponded: 'ms-survey-set-responded',
  completed: 'ms-survey-completed',
  redirect: 'ms-survey-redirect',
}

export const isIframe = window.self !== window.top;

export const isPreviewMode = getUrlParam('preview_mode') === 'true';

export function isMobile() {
  const hasTouchScreen = (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );

  const userAgentMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return hasTouchScreen && userAgentMobile;

}

export function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export function parseImgUrl(url) {
  if (!startsWith(url, process.env.VUE_APP_API_URL) || process.env.NODE_ENV === "dev") return url

  let arSplittedUrl = url.split("/")
  return process.env.VUE_APP_IMAGEKIT_URL_ENDPOINT + arSplittedUrl[arSplittedUrl.length - 1] + "?tr=w-700"
}

export function getUrlParam(param) {
  try {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
  } catch (error) {
    // Handle any potential errors (e.g., cross-origin issues)
    console.error(error);
    return null;
  }
}

export function listUrlParamsStr() {
  try {
    let paramsList = [];
    const urlParams = new URLSearchParams(window.location.search);

    for (const param of urlParams.entries()) {
      let itemStr = `${param[0]}=${param[1]}`;
      paramsList.push(itemStr);
    }

    return paramsList.join(',');
  } catch (error) {
    // Handle any potential errors (e.g., cross-origin issues)
    console.error(error);
    return '';
  }
}

export function setBackground(color) {
  if (!color) return;

  const body = document.getElementsByTagName('body')[0]
  body.style.backgroundColor = color
}

export function surveyPostMessage(type, data) {
  window.top.postMessage({type, data}, '*');
}

export function checkForCustomDomain(survey) {
  if (
    process.env.NODE_ENV !== "dev" &&
    location.hostname !== process.env.VUE_APP_DEFAULT_DOMAIN &&
    !survey?.custom_domain?.verifiedDomain
  ) {
    const currentUrl = new URL(location.href);
    currentUrl.hostname = process.env.VUE_APP_DEFAULT_DOMAIN;
    location.href = currentUrl.toString();
  }
}

export function checkIfCompleted(surveyId) {
  return new Promise((resolve) => {
    if (isPreviewMode) {
      resolve(false);
      return;
    }

    if (isIframe) {
      const timeoutMs = 2000;
      let settled = false;

      const handleMessage = (event) => {
        if (event?.data?.type === postMessageTypes.getResponded) {
          cleanup();
          settled = true;
          resolve(!!event?.data?.data?.isResponded);
        }
      };

      const cleanup = () => {
        window.removeEventListener('message', handleMessage);
        clearTimeout(timeoutId);
      };

      window.addEventListener('message', handleMessage);

      const timeoutId = setTimeout(() => {
        if (!settled) {
          cleanup();
          resolve(false);
        }
      }, timeoutMs);

      surveyPostMessage(postMessageTypes.getResponded, {key: `ms-${surveyId}`});
    } else {
      resolve(!!window.localStorage.getItem(`ms-${surveyId}`));
    }
  });
}

export function setCompleted(surveyId, data) {
  const key = `ms-${surveyId}`;
  const answers = JSON.stringify(data?.responses);

  if (isIframe) {
    surveyPostMessage(postMessageTypes.completed, data);
    surveyPostMessage(postMessageTypes.setResponded, {key, answers});
    return;
  }

  if (!isPreviewMode) {
    window.localStorage.setItem(key, answers);
  }
}

export function redirect(url) {
  if (!url) return;

  const redirectFunction = isIframe
    ? () => surveyPostMessage(postMessageTypes.redirect, {url})
    : () => (window.top.location.href = url);

  setTimeout(redirectFunction, process.env.VUE_APP_REDIRECT_TIMEOUT);
}
